import { render, staticRenderFns } from "./interventiondetailadmin.vue?vue&type=template&id=c0726a66&scoped=true&"
import script from "./interventiondetailadmin.vue?vue&type=script&lang=js&"
export * from "./interventiondetailadmin.vue?vue&type=script&lang=js&"
import style0 from "./interventiondetailadmin.vue?vue&type=style&index=0&id=c0726a66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0726a66",
  null
  
)

export default component.exports